import { render, staticRenderFns } from "./UploadFileAsUserModal.vue?vue&type=template&id=c94e877e&scoped=true"
import script from "./UploadFileAsUserModal.vue?vue&type=script&lang=js"
export * from "./UploadFileAsUserModal.vue?vue&type=script&lang=js"
import style0 from "./UploadFileAsUserModal.vue?vue&type=style&index=0&id=c94e877e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94e877e",
  null
  
)

export default component.exports